export default "__VITE_ASSET__c728b462__"